import {
  IoAlertCircle,
  IoCheckmarkCircle,
  IoInformationCircle,
  IoWarning,
} from 'react-icons/io5';
import { Icon, Toast, useToastStyles } from '@chakra-ui/react';

type ToastIndicatorProps = {
  type: string;
};

const toastIconMap: Record<string, React.ElementType> = {
  success: IoCheckmarkCircle,
  error: IoAlertCircle,
  warning: IoWarning,
  info: IoInformationCircle,
};

export const ToastIndicator = ({ type }: ToastIndicatorProps) => {
  const styles = useToastStyles();
  const IconComponent = toastIconMap[type];
  if (!IconComponent) return <Toast.Indicator />;
  return <Icon as={IconComponent} css={styles.indicator} h={6} w={5} />;
};
